import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_bath_body: FaireCategoryEntity = {
  token: "catalog_cat_bath-body",
  type: "category",
  name: "Bath & body",
  count: 1,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
